export const capitaliseFirstLetter = (string)=>string.replace(/(^|\s|-)([a-z])/g, (_, leadingWhitespaceOrHyphen, lowercaseLetter)=>leadingWhitespaceOrHyphen + lowercaseLetter.toUpperCase());
